import { render, staticRenderFns } from "./SegmentForm.vue?vue&type=template&id=63546b2c&"
import script from "./SegmentForm.vue?vue&type=script&lang=js&"
export * from "./SegmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports